import * as React from 'react';

export const enum SubMenuState {
    Closed,
    OpenByKeyboard,
    OpenByOther,
}

export function useSubMenuState(): [
    state: SubMenuState,
    openWithKeyboard: () => void,
    openWithOther: () => void,
    close: () => void
] {
    const [subMenuState, setSubMenuState] = React.useState(SubMenuState.Closed);

    const openWithKeyboard = React.useCallback(() => {
        setSubMenuState(SubMenuState.OpenByKeyboard);
    }, []);
    const openWithOther = React.useCallback(() => {
        setSubMenuState(SubMenuState.OpenByOther);
    }, []);
    const close = React.useCallback(() => {
        setSubMenuState(SubMenuState.Closed);
    }, []);

    return [subMenuState, openWithKeyboard, openWithOther, close];
}
